import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { Text } from '@/components/ui/Typography/Body/Text';
import { caseOnePath } from '@/utils/router/links';
/**
 * コラムサイドメニュー：「人気の選定支援事例」のコンポーネント
 * @param props
 * @constructor
 */
export const PopularCaseListItem = (props) => {
    const { className, id, src, title, webpSrc } = props;
    return (_jsxs(RouterLink, Object.assign({ className: clsx('flex group cursor-pointer gap-x-[10px]', className), to: caseOnePath(`${id}`) }, { children: [_jsx("div", Object.assign({ className: 'shrink-0' }, { children: _jsx("div", Object.assign({ className: 'overflow-hidden w-[120px] h-[75px] shadow-lg' }, { children: _jsx(ImageBase, { alt: title, isHoverZoom: true, objectPosition: 'cover', src: src, webpSrc: webpSrc }) })) })), _jsx(Text, Object.assign({ className: 'inline-block !leading-[16px] group-hover:text-primary group-hover:font-bold', size: 'sm', tagName: 'span' }, { children: title }))] })));
};
